import './about.css';
import { createPortal } from 'react-dom';
import { useEffect,useState } from 'react';

const items = [
  {
    src: '/about/gallery/3.0.png',
    type: 'image'
  },
  {
    src: '/about/gallery/0.1.01.mp4',
    type: 'video'
  },
  {
    src: '/about/gallery/mobile.mp4',
    type: 'video'
  },
  {
    src: '/about/gallery/0002.mp4',
    type: 'video'
  }
];

const AboutGallery = () => {
  const [activeItem, setActiveItem] = useState(null);

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        setActiveItem(null);
      }
    };

    window.addEventListener('keydown', handleEscape);

    return () => {
      window.removeEventListener('keydown', handleEscape);
    };
  }, []);

  const overlay = activeItem && createPortal(
    <div
      className='about-gallery-overlay'
      onClick={() => setActiveItem(null)}
    >
      {activeItem.type === 'video' ? (
        <video
          className='about-gallery-expanded'
          src={activeItem.src}
          controls
          autoPlay
          onClick={(e) => e.stopPropagation()}
        />
      ) : (
        <img
          className='about-gallery-expanded'
          src={activeItem.src}
          alt='Expanded Phi Corp Gallery'
          onClick={(e) => e.stopPropagation()}
        />
      )}
    </div>,
    document.body
  );

  return (
    <>
      <div className='about-gallery'>
        {items.map((item) => (
          item.type === 'video' ? (
            <video
              key={item.src}
              className='about-gallery-image'
              src={item.src}
              muted
              autoPlay
              loop
              playsInline
              onClick={() => setActiveItem(item)}
            />
          ) : (
            <img
              key={item.src}
              className='about-gallery-image'
              src={item.src}
              alt='Phi Corp Gallery'
              onClick={() => setActiveItem(item)}
            />
          )
        ))}
      </div>

      {overlay}
    </>
  );
};

export default AboutGallery;